import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=41a896e9&scoped=true&"
import script from "./reason.vue?vue&type=script&lang=js&"
export * from "./reason.vue?vue&type=script&lang=js&"
import style0 from "./reason.vue?vue&type=style&index=0&id=41a896e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a896e9",
  null
  
)

export default component.exports